// Retention strip copy (spec «Галерея клиента» 60): the banner exists only while a
// deletion date is set AND it is at most 60 days out. A past date never reaches the
// banner — entry already refuses the link.
export const RETENTION_BANNER_MAX_DAYS = 60;

const DAY_MS = 24 * 60 * 60 * 1000;

// Whole UTC calendar days on both sides: expiry is stored as the photographer's
// picked day at 23:59:59 UTC, and a day-granular diff keeps the strip steady for
// the whole day instead of flipping mid-afternoon at the 60-day mark.
const utcDay = (date: Date): number => Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

// UTC for the same reason — a local-time format would print the neighbouring day
// for a 23:59:59 UTC expiry east of Greenwich.
const longRuDate = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });

/**
 * «13 декабря 2026» — long Russian date, without the « г.» Intl appends. The ONE
 * long-date form the public gallery prints: the retention strip and the cover
 * date sit on the same screen and must not read as two different date styles.
 */
export function longRuDateText(date: Date): string {
  return longRuDate.format(date).replace(/\s*г\.$/u, '');
}

/** «до 13 декабря 2026» — the retention strip's date half. */
export function retentionDateText(until: Date): string {
  return `до ${longRuDateText(until)}`;
}

/** `null` = no banner. Otherwise the two tones the strip paints separately. */
export function retentionBanner(
  untilIso: string | null | undefined,
  now: Date = new Date(),
): { lead: string; date: string } | null {
  if (!untilIso) return null;
  const until = new Date(untilIso);
  if (Number.isNaN(until.getTime())) return null;
  const daysLeft = (utcDay(until) - utcDay(now)) / DAY_MS;
  if (daysLeft < 0 || daysLeft > RETENTION_BANNER_MAX_DAYS) return null;
  return { lead: 'Галерея хранится', date: retentionDateText(until) };
}
